import { FunctionComponent } from "react";

import LightBulb from "@/assets/icons/light-bulb.svg";

import styles from "./Topic.module.css";

export type TopicProps = {
  className?: string;
  topic_names: string[];
};

const Topic: FunctionComponent<TopicProps> = ({ className, topic_names }) => {
  return topic_names && topic_names.length > 0 ? (
    <div className={className}>
      <span data-testid="topics-indicator" className={styles.topic}>
        <LightBulb height={18} width={18} className={styles.icon} />
        {topic_names?.map((topic, index, arr) => (
          <span key={topic}>
            {topic}
            {index < arr.length - 1 ? ", " : ""}
          </span>
        ))}
      </span>
    </div>
  ) : null;
};

export default Topic;
